import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudtrailService } from '../../service';

export type TrailEncryptionConfig = typeof TrailEncryptionConfig._.Config;

export const TrailEncryptionConfig = IntegrationConfig.make({
  service: CloudtrailService,
  name: Integration_Handler_Names_Enum.TrailEncryption,
  configSchema: z.object({}),
});
